import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { KYMW1001Component } from './kymw1001.component';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { GetInfomationService } from './api-services/get-infomation.service';
import { GetCommonSettingService } from './api-services/get-common-setting.service';
import { GetPageSettingService } from './api-services/get-page-cnt-list.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { FunctionMenuModule } from '../../../commons/kymw02/function-menu/function-menu-module';
import { GetInitTopService } from './api-services/get-init-top.service';
import { LoginUserInfoService } from './login-services/loginUserInfo.service';

/**
 * メインメニュー画面　モジュール設定クラス
 *
 * 提供時：
 * app/main/main.module.ts
 *
 * @export KYMW1001Module
 * @class KYMW1001Module
 */
@NgModule({
  declarations: [
    KYMW1001Component
  ],
  imports: [
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    NgbTooltipModule,
    AppCommonsModule,
  ],
  exports: [
    KYMW1001Component
  ],
  providers: [
    KYMW1001Component,
    GetInfomationService,
    GetCommonSettingService,
    GetPageSettingService,
    GetInitTopService,
    LoginUserInfoService,
  ],
})
export class KYMW1001Module { }
